import jwtDecode, {JwtPayload} from 'jwt-decode';

export const decodeToken = (token: string): JwtPayload => jwtDecode<JwtPayload>(token);

export const getTokenExpirationDate = (token: string): number => {
  const decoded = decodeToken(token).exp;
  const date = new Date(0);

  return decoded ? date.setUTCSeconds(decoded) : date.valueOf();
};

export const isTokenExpired = (token: string): boolean => {
  const date = getTokenExpirationDate(token);

  if (!date) {
    return true;
  }

  return date < new Date().valueOf();
};

export const regExpToken = (token = ''): boolean =>
  /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/.test(token);

export const getToken = (): string => localStorage.getItem('TISA_TOKEN') || '';

export const setToken = (token: string): void =>
  localStorage.setItem('TISA_TOKEN', token);

export const clearToken = (): void => localStorage.removeItem('TISA_TOKEN');
